import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { GetterTypes } from "@/store";
import { AllActionTypes } from "@/store/actionTypes";
import { IconType } from "@/types/icons";
import DesktopSelectChatWrapper from "../chat/chatContainer/DesktopSelectChatWrapper/DesktopSelectChatWrapper.vue";
import {
  useComputedValue,
  useGetDesktopChatSelectProperties,
} from "@/composables";
import { Chat } from "@/store/chats/types";
import { computed } from "vue";
import { User } from "@/store/users/state";
import { getDifferenceArray } from "@/utils/modifiers";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'PopupEditGroupMembers',
  setup(__props) {

const chat = useComputedValue<Chat>(GetterTypes.GET_SELECTED_CHAT);
const chatMembers = computed(() => chat.value.members ?? []);
const { dispatch } = useStore();

const {
  isAddMembersShown,
  members,
  addMember: defaultAddMember,
  removeMember,
  showAddMembers,
} = useGetDesktopChatSelectProperties({
  defaultMembers: chatMembers.value.filter(
    (member) => member.id !== chat.value.createdBy,
  ),
});

const addMember = (member: User) => {
  defaultAddMember(member);
  isAddMembersShown.value = false;
};

const saveChanges = () => {
  const memberIds = members.value.map((m) => String(m.id));
  const chatMemberIds = chatMembers.value.map((m) => String(m.id));
  const addMemberIds = getDifferenceArray(memberIds, chatMemberIds);
  const removeMemberIds = getDifferenceArray(chatMemberIds, memberIds);

  dispatch(AllActionTypes.UPDATE_GROUP_CHAT_MEMBERS, {
    chatId: chat.value.id,
    addMemberIds,
    removeMemberIds,
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DesktopSelectChatWrapper, {
    members: _unref(members),
    action: _unref(showAddMembers),
    "item-icon": _unref(IconType).TRASH,
    title: _ctx.$t('popup.PopupEditGroupMembers.headerMain'),
    "action-title": _ctx.$t('popup.PopupEditGroupMembers.headerAdd'),
    "confirm-title": _ctx.$t('popup.PopupEditGroupMembers.btnSave'),
    "is-add-members-shown": _unref(isAddMembersShown),
    onAddMember: addMember,
    onItemAction: _unref(removeMember),
    onConfirm: saveChanges
  }, null, 8, ["members", "action", "item-icon", "title", "action-title", "confirm-title", "is-add-members-shown", "onItemAction"]))
}
}

})